<template>
  <div v-if="detailData.task" class="out_box">
    <div class="detail_t_box">
      <div>
        <div class="detail_t">
          <div>
            <div class="detail_label">批次</div>
            <div class="detail_value">{{detailData.task.batch_number}}</div>
          </div>
          <div style="margin-left: 16px;">
            <div class="detail_label">状态</div>
            <div v-if="detailData.task.status == 0" class="table_type2">已取消</div>
            <div v-else>
            <div v-if="detailData.task.completed_num == 0" class="table_type1">未生成</div>
            <div v-else-if="detailData.task.completed_num / detailData.task.num < 0.75" class="table_type3">
              生成中
            </div>
            <div v-else-if="detailData.task.completed_num / detailData.task.num == 1" class="table_type4">
              完成
            </div>
          </div>
        </div>
        </div>
        <div class="detail_t2">
          <div>创建时间：{{detailData.task.create_time}}</div>
          <!-- <div style="margin-left: 24px;">生成模式：通用</div> -->
          <div style="margin-left: 24px;">比例尺寸：{{detailData.task.size}}</div>
          <div style="margin-left: 24px;">数量：{{detailData.task.num}}</div>
          <div style="margin-left: 24px;" class="t2_status">成功：{{detailData.task.completed_num}}</div>
        </div>
      </div>
      <!-- <div>
        <el-button class="btn_edit">重新编辑</el-button>
        <el-button class="btn_plain">任务参数</el-button>
        <el-button class="btn_plain">备注</el-button>
      </div> -->
    </div>
    <div class="btn_box" :class="{is_fixed: isFixed}" :style="isFixed ? `width: ${btnBoxWidth}px` : ''">
      <div>
        <el-button class="btn_download" style="width: 42px;padding: 0;" @click="$router.back()"><i class="el-icon-arrow-left"></i></el-button>
        <el-button class="btn_download" @click="downloadAll(detailData.task.batch_number, 'all')">下载全部</el-button>
        <el-button class="btn_download" @click="downloadAll(detailData.task.batch_number, 'isSelect')" v-if="showOperate">下载选中</el-button>
        <el-dropdown @command="selectedAllSingle">
          <el-button class="el-dropdown-link btn_plain">快速选中</el-button>
          <el-dropdown-menu slot="dropdown" v-if="selectAllLen">
            <el-dropdown-item command="all">选择全部</el-dropdown-item>
            <el-dropdown-item command="original">选择原图</el-dropdown-item>
            <el-dropdown-item v-for="(item, index) in selectAllLen" :command="index">选择第{{item}}张</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="btn_plain" @click="exportAll">导出数据</el-button>
        <el-button class="btn_plain" @click="tempExport">按模版导出 </el-button>
        <ImageOperate v-if="showOperate" ref="ImageOperateRef" :imageList="detailData.artworks" />
      </div>
      <div>
        <!-- v-if="multipleSelection.length" <el-button class="btn_right">批量操作</el-button> -->
        <el-button class="btn_right" @click="getDetail">刷新</el-button>
      </div>
    </div>
    <div class="placecss" v-show="isFixed"></div>
    <div class="line_box" v-for="(item, index) in detailData.artworks">
      <div class="line_l">
        <div class="line_t">
          <div>
            <el-checkbox v-model="item.orichecked" style="margin-right: 8px;"></el-checkbox>
            原图
          </div>
          <div class="line_t_download" @click="downloadSingleImage(item.prompt, `原图${index+1}`)">
            下载 <img src="@/assets/images/download.png">
          </div>
        </div>
        <div class="line_l_main">
          <div class="line_l_img">
            <el-image :src="item.prompt" fit="contain" :preview-src-list="[item.prompt]"></el-image>
          </div>
          <div class="line_title" v-if="item.image_title" :title="item.image_title">{{ item.image_title }}</div>
        </div>
      </div>
      <i class="el-icon-d-arrow-right"></i>
      <div class="line_r">
        <div class="line_t">
          <div> 
            <el-checkbox :indeterminate="item.indeterminate" v-model="item.checked" style="margin-right: 8px;" @change="checkedAllChange($event, item)" :disabled="!item.image_url"></el-checkbox>
            生成图
          </div>
          <div class="line_t_download" @click="multipleDownload(item.image_urls, detailData.task.batch_number + '组' + (index + 1))">
            下载 <img src="@/assets/images/download.png">
          </div>
        </div>
        <div v-if="item.err_msg" class="line_img">{{ item.err_msg }}</div>
        <div v-else class="line_img">
          <div class="line_img_item" v-for="(iten, indey) in item.image_urls">
            <div style="position: relative;">
              <el-checkbox v-model="iten.checked" @change="checkedSingleChange($event, item)"></el-checkbox>
              <div class="line_img_mask">
                <div class="line_img_prev" @click="previewImage(index, indey)"><i class="el-icon-view"></i></div>
                <div class="line_img_btn" @click="downloadSingleImage(iten.url, `image${index}-${indey}`)">下载</div>
              </div>
              <div class="line_img_main">
                <ImageContrast :src="iten.url" :originSrc="item.prompt" :ref="`img_urls${index}${indey}`" />
                <!-- <el-image :src="iten.url" fit="contain" :preview-src-list="[iten.url]" :ref="`img_urls${index}${indey}`"></el-image> -->
              </div>
            </div>
            <div class="line_title" v-if="item.image_title" :title="item.image_title">{{ item.image_title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_bottom" :style="{width: `${btnBoxWidth}px`}" :class="{imageless: detailData.artworks.length < 2}" v-if="showOperate">
      <div class="selected_num">已选择 {{showOperate}} 张
      </div>
    </div>
    <ExportAccordTemp ref="ExportAccordTempRef" pageType="ai" :dataIds="group_ids" />
  </div>
</template>
<script>
import { aiGetDetail, aiExportExcel } from '@/api/imgAndText'
import { downloadImages, downloadSingleImage } from '@/utils/download'
import FixedTop from './FixedTop'

import ExportAccordTemp from "@/components/ExportAccordTemp.vue";
import ImageOperate from "@/components/ImageOperate.vue";
import ImageContrast from '@/components/imageContrast.vue';
export default {
  name: "SetPictureDetail",
  components: { ExportAccordTemp, ImageOperate, ImageContrast },
  mixins: [ FixedTop ],
  data () {
   return {
    checked: false,
    detailData: {},

    selectAllLen: 0,
    group_ids: [],
   }
  },
  created() {
    this.getDetail()
  },
  computed: {
    showOperate() {
      let selectLen = 0;
      this.detailData.artworks.forEach(item => {
        let imgslen = item.image_urls.filter(iten => iten.checked)
        selectLen = selectLen + imgslen.length + (item.orichecked ? 1 : 0)
      })
      // let haschecked = this.detailData.artworks.find(item => item.image_urls.some(iten => iten.checked) || item.orichecked)
      return selectLen
    }
  },
  methods:{
    downloadSingleImage,
    tempExport() {
      this.group_ids = [];
      this.detailData.artworks.forEach((item) => {
        let position = []
        item.image_urls.forEach((iten, indey) => {
          if(iten.checked) {
            position.push(indey)
          }
        })
        if(position.length) {
          this.group_ids.push({id: item.id, position: position})
        }
      })
      if(this.group_ids.length) {
        this.$refs.ExportAccordTempRef.dialogTempVisible = true
      }else {
        this.$message.warning("请选择要按模板导出的图片");
      }
    },
    checkedAllChange(val, item) {
      if(val) {
        item.checkedLength = item.image_urls.length
      }else {
        item.checkedLength = 0
      }
      item.image_urls.forEach(iten => {
        iten.checked = val
      })
      item.indeterminate = false
    },
    checkedSingleChange(val, item) {
      val ? item.checkedLength++ : item.checkedLength--
      this.$set(item, 'checked', item.checkedLength == item.image_urls.length) 
      // item.checked = item.checkedLength == item.image_urls.length
      this.$set(item, 'indeterminate', item.checkedLength > 0 && item.checkedLength < item.image_urls.length)
      // item.indeterminate = item.checkedLength > 0 && item.checkedLength < item.image_urls.length
    },
    downloadAll(name, type) {
      let dataList = [];
      this.detailData.artworks.forEach((item) => {
        if(type == 'isSelect' && item.orichecked) {
          dataList.push({
            name: "image" + item.ai_task_id + "-原图.png",
            url: item.prompt,
          });
        }
        item.image_urls.forEach((img, index) => {
          if((type == 'isSelect' && img.checked) || type == 'all') {
            dataList.push({
              name: "image" + item.ai_task_id + '-' + index + ".png",
              url: img.url,
            });
          }
        });
      });
      if (dataList.length > 0) {
        downloadImages(dataList, name);
      } else {
        this.$message.warning("暂无生成图");
      }
    },
    selectedAllSingle(command) {
      this.detailData.artworks.forEach(item => {
        if(command == 'original') {
          item.orichecked = true
          item.image_urls.forEach((iten, indey) => {
            iten.checked = false
          })
          item.checkedLength = 0
          item.checked = false
          item.indeterminate = false
        } else if(command == 'all') {
          item.orichecked = true
          item.image_urls.forEach((iten, indey) => {
            iten.checked = true
          })
          item.checkedLength = item.image_urls.length
          item.checked = true
          item.indeterminate = false
        } else {
          if(item.image_url) {
            item.orichecked = false
            item.image_urls.forEach((iten, indey) => {
              iten.checked = indey == command
            })
            item.checkedLength = 1
            item.checked = item.checkedLength == item.image_urls.length
            item.indeterminate = item.checkedLength > 0 && item.checkedLength < item.image_urls.length
          }
        }
      });
    },
    selectedAll() {
      this.detailData.artworks.forEach(item => {
        if(item.image_url) {
          this.$set(item, "checked", true);
          item.image_urls.forEach((img) => {
            this.$set(img, "checked", true);
          });
        }
      });
    },
    async exportAll() {
      let dataList = [];
      this.detailData.artworks.forEach((item) => {
        if(item.checked) {
          dataList.push(item.id)
        }
      })
      if(dataList.length) {
        aiExportExcel({artwork_ids: dataList}).then(res => {
          // await fetch(res.data.url).then(ress => {
          //   ress.blob()
          // }).then(blob => {
            let a = document.createElement("a");
            // a.href = URL.createObjectURL(blob)
            a.href = res.data.url
            a.download = this.detailData.task.batch_number
            document.body.appendChild(a)
            a.click()
          // })
          // let url = '/path/to/' + res.data
          // this.$download(url, this.detailData.task.batch_number)
        })
      }else {
        this.$message.warning("请选择要导出的图片组");
      }
    },
    multipleDownload(imagelist, name) {
      let dataList = [];
      imagelist.forEach((img, index) => {
        if (img.checked) {
          dataList.push({
            name: "image" + (index + 1) + ".png",
            url: img.url,
          });
        }
      });
      if (dataList.length > 0) {
        downloadImages(dataList, name);
      } else {
        this.$message.warning("请选择图片");
      }
    },
    previewImage(index, indey) {
      const refName = `img_urls${index}${indey}`;
      setTimeout(() => {
        this.$refs[refName][0].$el.children[0].click();
      }, 60);
    },
    getDetail() {
      aiGetDetail(this.$route.query.id).then(res => {
        res.data.artworks.forEach(item => {
          item.orichecked = false
          item.checked = false
          item.indeterminate = false
          item.checkedLength = 0
          item.image_urls = []
          if(item.image_url) {
            let urlArr = item.image_url.split(',')
            this.selectAllLen = urlArr.length
            urlArr.forEach(iten => {
              item.image_urls.push({
                checked: false,
                url: iten
              })
            })
          }
        })
        this.detailData = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .btn_plain {
    background: transparent;
    border: 1px solid #132632;
    color: #132632;
  }
  .detail_t_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #595959;
    .detail_t {
      display: flex;
      .detail_label {
        color: #132632;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .detail_value {
        color: #132632;
        font-size: 20px;
        font-weight: 700;
      }
      .table_type1, .table_type2, .table_type3, .table_type4 {
        width: 60px;
        height: 20px;
        text-align: center;
        margin-top: 16px;
        line-height: 17px;
        font-size: 12px;
        border-radius: 4px;
      }
      .table_type1 {
        color: #333333;
        background: rgba(191, 191, 191, 0.3);
        border: 1px solid #BFBFBF;
      }
      .table_type2 {
        color: #FF5733;
        background: rgba(255, 87, 51, 0.35);
        border: 1px solid #FF5733;
      }
      .table_type3 {
        color: #729E13;
        background: rgba(165, 214, 63, 0.35);
        border: 1px solid #A5D63F;
      }
      .table_type4 {
        color: #3EC775;
        background: rgba(179, 252, 209, 0.3);
        border: 1px solid #3FBF72;
      }
    }
    .detail_t2 {
      color: #38454B;
      font-size: 14px;
      margin-top: 24px;
      display: flex;
      margin-bottom: 32px;
      .t2_status {
        color: #43CF7C;
      }
    }
    .el-button+.el-button {
      margin-left: 16px;
    }
    .btn_edit {
      border-radius: 8px;
      background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
      color: #acaf0b;
      font-size: 20px;
      border: none;
      height: 52px;
    }
    .btn_plain {
      border-radius: 8px;
      height: 52px;
      font-size: 20px;
    }
  }
  .btn_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 32px;
    .el-button+.el-button {
      margin-left: 24px;
    }
    .el-dropdown {
      margin: 0 24px;
    }
    .btn_download, .btn_plain, .btn_right {
      border-radius: 8px;
      height: 42px;
      font-size: 16px;
    }
    .btn_download {
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      color: #F7F8FA;
    }
    .btn_right {
      width: 112px;
      background: linear-gradient(90deg, #FF5733 0%, #FAAC5F 100%);
      color: #FFFFFF;
      border: none;
    }
    &.is_fixed {
      position: fixed;
      background: #FFFFFF;
      z-index: 101;
      top: 0;
      padding: 24px 0;
      border-bottom: 1px solid #ededed;
    }
  }
  .placecss {
    height: 74px;
  }
  .line_box {
    border-radius: 8px;
    background: #F7F8FA;
    padding: 24px;
    border: 1px solid #FFFFFF;
    display: flex;
    align-items: center;
    margin-top: 36px;
    .line_t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px 8px 8px;
      border-bottom: 1px solid #EDEDED;
      font-size: 12px;
      .line_t_download {
        background: linear-gradient(90deg, #DE705F 0%, #E68C93 100%);
        color: #fff;
        border-radius: 24px;
        width: 64px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        cursor: pointer;
        img {
          margin-left: 4px;
          vertical-align: middle;
        }
      }
    }
    .line_l {
      flex-shrink: 0;
      width: 19.3%;
      border-radius: 4px;
      background: #FFFFFF;
      .line_l_main {
        width: 100%;
        padding: 16px 8px;
        // border: 1px solid #343F5C;
        .line_l_img {
          position: relative;
          &::after {
            padding-top: 100%;
            content: '';
            display: block;
          }
          .el-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      .line_l_thumb {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 8px;
        .line_thumb {
          width: 40px;
          height: 40px;
          border: 1px solid #343F5C;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            object-fit: contain;
          }
        }
      }
    }
    .el-icon-d-arrow-right {
      margin: 0 24px;
      font-size: 32px;
      font-weight: 700;
    }
    .line_r {
      flex: 1;
      align-self: stretch;
      border-radius: 4px;
      background: #FFFFFF;
      .line_img {
        display: flex;
        flex-wrap: wrap;
        gap: 0.6%;
        margin: 16px 8px;
        .line_img_item {
          width: 24.5%;
          // height: 229px;
          // margin-bottom: 24px;
          .el-checkbox {
            position: absolute;
            top: 16px;
            left: 16px;
            z-index: 2;
          }
          .line_img_mask {
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            background: rgba(3, 3, 3, 0.6);
            display: none;
            flex-direction: column;
            // align-items: center;
            // justify-content: center;
            // gap: 16px;
            .line_img_prev {
              flex: 1;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 22px;
              cursor: pointer;
            }
            .line_img_btn {
              // border-radius: 24px;
              background: #27292D;
              color: #FFFFFF;
              font-size: 14px;
              // width: 84px;
              height: 44px;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              img {
                vertical-align: middle;
              }
            }
          }
          .line_img_main {
            position: relative;
            
            &::after {
              padding-top: 100%;
              content: '';
              display: block;
            }
            /deep/ .contrast_img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          &:hover .line_img_mask {
            display: flex;
          }
        }
      }
    }
    .line_title {
      text-align: center;
      margin-top: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
    }
  }
  .fixed_bottom {
    position: fixed;
    bottom: 0;
    z-index: 9;
    background: #fff;
    .selected_num {
      line-height: 64px;
      color: #737373;
      font-size: 14px;
    }
    &.imageless {
      padding: 0 16px;
      right: 24px;
      box-sizing: content-box;
    }
  }
}
</style>